import { useQuery } from '@apollo/client';
import { useKeycloak } from '@react-keycloak/web';
import _ from 'lodash';
import { getUserResources } from '@dreebit-registry/vsm-microservice-components';
import { InstalledBaseNodeContactLinkContext } from '../graphql/queries/installedBaseNodeContactLinkContext';
import { buildNodeDetailTabUrl, NodeDetailTabTarget } from '../utils/nodeDetailTabUrl';

/**
 * Link into a node's contact tab in the installed base tree — the "+ N more"
 * and "Assign" target of the dashboard hero cards. `url` is null until the
 * node's path has loaded (or when `skip`); `canAssign` uses the same gate as
 * the contact tab itself (InstalledBaseNodeDetailPanel).
 */
const useNodeContactTabLink = (nodeId: string | undefined | null, skip = false): { url: NodeDetailTabTarget | null; canAssign: boolean } => {
    const { keycloak } = useKeycloak();
    const { data } = useQuery(InstalledBaseNodeContactLinkContext, {
        variables: { id: nodeId },
        skip: skip || !nodeId,
    });

    const node = _.get(data, 'installedBaseNode');
    if (!node || !nodeId) return { url: null, canAssign: false };

    const pathNodeIds = (node.pathNodes ?? []).map((pathNode: { id?: string } | null) => pathNode?.id);
    return {
        url: buildNodeDetailTabUrl(nodeId, pathNodeIds, 'contact'),
        canAssign: !!node.access?.write
            && getUserResources(keycloak.token, 'otto_crm').includes('administrateContactPersons'),
    };
};

export default useNodeContactTabLink;
